import { format as convert } from "date-fns-jalali";

export const getJalaliDate = ({
  date,
  format,
}: {
  date?: string;
  format?: string;
}): string => {
  if (!date) return "";
  if (date.startsWith("0001-01-01")) return "-";

  return convert(new Date(date), format || "yyyy/MM/dd");
};

export const getHourDiff = (dt2: Date, dt1: Date) => {
  let diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60 * 60;
  return Math.abs(Math.round(diff));
};
